import { canDoIt, isA } from '_utils/policies';
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";
import { reduxActions as USER } from "_constants/user.constants";

const login = {
  [USER.LOGIN_STARTED]: (state, { payload }) => ({
    ...state,
    own: {
      ...state.own,
      status: LOADING,
      data: payload?.data ?? null
    }
  }),
    
  [USER.LOGIN_SUCCESS]: (state, { payload }) => {
    let user = payload?.data?.[0] ?? null;
    if (user !== null) {
      Object.defineProperties(user.__proto__, {
        'canDoIt': {
          value: canDoIt
        },
        'isA': {
          value: isA
        }
      });
    };
    return {
      ...state,
      own: {
        ...state.own,
        status: SUCCESS,
        data: user
      }
    };
  },

  [USER.LOGIN_FAIL]: (state, { payload }) => ({
    ...state,
    own: {
      ...state.own,
      error: payload?.error ?? null,
      status: FAILURE,
    }
  })
};

export default login;
